import axios from 'axios';
import { getLanguageCode, messageMatch } from '@ugc-utils/utils';
import { HttpStatus } from '@ugc-utils/http-status';
import state from '@ugc-store';
import { handlePxResponse } from '@ugc-utils/perimeterx';
const UGC_API_PREFIX = '/ugc/';

declare global {
  interface Window {
    LANGUAGE_CODE: string;
  }
}

const handlePx = (e, isReloadPage = false) => {
  const { response: { status = 0, data = {} } = {}, config = {} } = e || {};
  if (status === HttpStatus.FORBIDDEN && data && data.appId && data.blockScript && config) {
    handlePxResponse(data, config.url, isReloadPage);
  }
};

axios.defaults.withCredentials = true;

const request = axios.create();

request.interceptors.request.use(async config => {
  try {
    const { url = '', headers = {} } = config;
    if (url.includes(UGC_API_PREFIX) && headers) {
      config.headers['x-fp-id'] = state.visitorId;
    }
  } catch (e) {}

  return config;
});

const get = async (url: string, params = {}, headers = {}, isHandleError = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await request.get(url, { params, headers });
      if (!data.businessViolations) {
        resolve(data);
      } else {
        isHandleError ? reject(messageMatch(-1, data.businessViolations[0].message)) : reject(data || {});
      }
    } catch (e) {
      handlePx(e, true);
      isHandleError
        ? reject(messageMatch(e.response && e.response.status, '', e.response && (e.response.data || {})))
        : reject(e.response || {});
    }
  });
};

const post = async (url: string, body = {}, config = {}, isHandleError = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await request.post(url, body, config);

      if (!data.businessViolations) {
        resolve(data);
      } else {
        isHandleError ? reject(messageMatch(-1, data.businessViolations[0].message)) : reject(data || {});
      }
    } catch (e) {
      handlePx(e);
      const response = e.response || {};
      isHandleError ? reject(messageMatch(response.status, '', response.data || {})) : reject(response || {});
    }
  });
};

const patch = async (url: string, body = {}, config = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await request.patch(url, body, config);

      if (!data.businessViolations) {
        resolve(data);
      } else {
        reject(messageMatch(-1, data.businessViolations[0].message));
      }
    } catch (e) {
      handlePx(e);
      const response = e.response || {};
      reject(messageMatch(response.status, '', response.data || {}));
    }
  });
};

const formatPublicParams = (action = {}) => ({ languageCode: getLanguageCode(), ...action });

export { get, post, patch, formatPublicParams };

export const prefix = '/ugc';
